/*
 * Reglas del bloque de imagen, las mismas que valida el backend al subir
 * (StoreLessonImageRequest, LMS-071): jpg, png, gif o webp (sin SVG) y como
 * máximo `lms.image_max_kb` (5 MB). Se comprueban antes de subir para no gastar
 * la petición; el backend sigue siendo quien decide.
 */
export const IMAGE_TYPES = ['image/jpeg', 'image/png', 'image/gif', 'image/webp']
export const IMAGE_ACCEPT = IMAGE_TYPES.join(',')
export const IMAGE_MAX_MB = 5

// Clave i18n del error o null si el fichero se puede subir.
export const imageFileError = (file) => {
    if (!IMAGE_TYPES.includes(file.type)) return 'projects.image_type_invalid'
    return file.size > IMAGE_MAX_MB * 1024 * 1024 ? 'projects.image_too_large' : null
}
